import React from "react";
import { ArrowUpRight, Hammer } from "lucide-react";
import { PWA } from "@/constants/testIds";
import { REAL } from "./data";
import Reveal from "./Reveal";

const ABOUT_IMG = REAL.branded_cutting_board;
const ABOUT_IMG_2 = REAL.stacked_boxes;

const About = () => {
  const go = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section
      id="about"
      data-testid={PWA.aboutSection}
      className="relative bg-[#FAF9F6] py-24 md:py-32 wood-grain"
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <Reveal className="lg:col-span-6 relative">
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="Precision Woodworking Artistry branded end-grain cutting board"
                data-testid={PWA.aboutImage}
                className="w-full h-[560px] md:h-[640px] object-cover bg-[#FAF9F6]"
              />
              <div className="absolute -bottom-10 -right-6 md:-right-10 w-48 h-60 md:w-60 md:h-72 hidden md:block">
                <img
                  src={ABOUT_IMG_2}
                  alt="Cherry and walnut boxes with contrasting spline joinery"
                  className="w-full h-full object-cover border-8 border-[#FAF9F6] bg-[#FAF9F6]"
                />
              </div>
              <div className="absolute top-6 left-6 bg-[#1A1A1A] text-[#FAF9F6] px-4 py-3 flex items-center gap-3">
                <Hammer className="w-4 h-4 text-[#C19A6B]" />
                <span className="text-[10px] tracking-[0.32em] uppercase">Est 2018</span>
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-6">
            <Reveal>
              <p className="text-[11px] tracking-[0.4em] uppercase text-[#5C4033] font-semibold mb-5">
                — About The Shop
              </p>
            </Reveal>
            <Reveal delay={120}>
              <h2 className="font-serif-display text-[#1A1A1A] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                Where Precision <br />
                <span className="italic text-[#5C4033]">Meets Artistry.</span>
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <div className="mt-8 h-px w-24 bg-[#C19A6B]" />
            </Reveal>
            <Reveal delay={280}>
              <p className="mt-8 text-[#1A1A1A]/85 text-lg leading-relaxed font-light">
                Precision Woodworking Artistry is a South Florida workshop building custom wood
                projects around the people who'll live with them. We design and craft furniture,
                cabinetry, built-ins, and architectural features that fit your space, your style,
                and the way you actually use a room.
              </p>
            </Reveal>
            <Reveal delay={360}>
              <p className="mt-5 text-[#1A1A1A]/75 text-base md:text-lg leading-relaxed font-light">
                Every project starts with a real conversation and ends with a piece you'll be proud
                of for decades. Solid hardwoods. Hand-fit joinery. Finishes that age beautifully.
                Nothing rushed. Nothing cookie-cutter.
              </p>
            </Reveal>

            <Reveal delay={460}>
              <div className="mt-10 grid grid-cols-3 gap-6 border-t border-b border-[#1A1A1A]/10 py-8">
                {[
                  { v: "15+", l: "Years Building" },
                  { v: "300+", l: "Custom Projects" },
                  { v: "100%", l: "Built To Order" },
                ].map((it) => (
                  <div key={it.l}>
                    <p className="font-serif-display text-4xl md:text-5xl text-[#5C4033]">{it.v}</p>
                    <p className="mt-2 text-[10px] tracking-[0.28em] uppercase text-[#1A1A1A]/60 font-semibold">
                      {it.l}
                    </p>
                  </div>
                ))}
              </div>
            </Reveal>

            <Reveal delay={540}>
              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <button onClick={() => go("#quote")} className="btn-walnut" data-testid="pwa-about-cta-quote">
                  Start Your Project
                  <ArrowUpRight className="w-4 h-4" />
                </button>
                <button onClick={() => go("#process")} className="btn-outline-dark" data-testid="pwa-about-cta-process">
                  See Our Process
                </button>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
